import ApplicationSerializer from 'lumen/serializers/application';

export default class ReviewSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'reviews') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('reviews/review');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }
}
